




@if(!inventoryAction) {
  <mat-spinner></mat-spinner>
} @else {

    <ng-container *ngIf="inventoryDetailsComponent">
      <ng-container #componentRef *ngComponentOutlet="inventoryDetailsComponent; inputs: {inventoryAction, dialogRef, reloadInventoryAction: reloadInventoryAction.bind(this)}"></ng-container>
    </ng-container>

    <ng-container *ngIf="!inventoryDetailsComponent">
      <ng-container *ngTemplateOutlet="default"></ng-container>
    </ng-container>
  
  <mat-toolbar class="footer" *ngIf="!loading()">
    @if (inventoryAction.document_id) {
      <div class="document-button-container">
        <button
          mat-button
          go-to-details
          [element]="inventoryAction.document"
          mode="modal"
          class="primary"
        >
          Ver {{inventoryAction.document.type | human}} #{{inventoryAction.document.correlative_id}}
        </button>
      </div>
    }
    @if (inventoryAction.stock) {
      <div class="document-button-container">
        <button
          mat-button
          go-to-details
          [element]="inventoryAction.stock"
          mode="modal"
          class="primary"
        >
          Ver {{inventoryAction.stock.type | human}} #{{inventoryAction.stock.correlative_id}}
        </button>
      </div>
    }
    @if (inventoryAction.buy_order) {
      <div class="document-button-container">
        <button
          mat-button
          go-to-details
          [element]="inventoryAction.buy_order"
          mode="modal"
          class="primary"
        >
          Ver {{inventoryAction.buy_order.type | human}} #{{inventoryAction.buy_order.correlative_id}}
        </button>
      </div>
    }
    @if (inventoryAction.folder) {
      <div class="document-button-container">
        <button
          mat-button
          go-to-details
          [element]="inventoryAction.folder"
          class="primary"
        >
          Ver {{inventoryAction.folder.type | human}} #{{inventoryAction.folder.correlative_id}}
        </button>
      </div>
    }
    @if (inventoryAction.invoice) {
      <div class="document-button-container">
        <button
          mat-button
          go-to-details
          [element]="inventoryAction.invoice"
          class="primary"
        >
          Ver {{inventoryAction.invoice.type | human}} #{{inventoryAction.invoice.correlative_id}}
        </button>
      </div>
    }
    <div class="expander"></div>
    @if(inventoryAction.status_id) {
      <button mat-raised-button color="accent" [matMenuTriggerFor]="menu">
        <i class="fa fa-pencil-alt"></i>
        <span class="hide-mobile">{{inventoryAction.status?.name  || (inventoryAction.status_id | status:'name': statuses)}}</span>
      </button>
    }
    <mat-menu #menu="matMenu">
      @for (status of statuses; track status.id) {
        <button
          mat-menu-item
          (click)="setStatus(status.id)"
          [style.color]="status.color"
          [disabled]="status.id === inventoryAction?.status_id"
          matTooltip="Estado actual"
          [matTooltipDisabled]="status.id !== inventoryAction?.status_id"
        >
          <span>{{status.name}}</span>
          @if (status.id === inventoryAction?.status_id) {
            &nbsp;
            <div class="fa fa-check"></div>
          }
        </button>
      }
    </mat-menu>
  </mat-toolbar>
}


<ng-template #default>
  
  <mat-toolbar class="header">
  
    <div class="back" (click)="goBack()" matTooltip="Atrás" matTooltipPosition="right">
      <mat-icon >arrow_back_ios_new</mat-icon>
    </div>
    <div>
      {{ title }}
    </div>
    <div class="expander"></div>

    <button mat-button [mat-menu-trigger-for]="menu"><mat-icon>more_horiz</mat-icon></button>
    <mat-menu #menu="matMenu">
      @if (inventoryAction?.type === 'InventoryAction::Stock' && inventoryAction?.invoice) {
        <button mat-menu-item>
          <mat-icon>remove_red_eye</mat-icon><a href="{{inventoryAction.invoice.url}}" target="_blank"> Ver {{'Invoice' | human}}</a>
        </button>
      } 
      <button mat-menu-item (click)="addChat()"><mat-icon>chat</mat-icon> Agregar al Chat</button>
    </mat-menu>
  </mat-toolbar>
  
  <div class="dialog-wrapper">
    @if(loading()) {
      <mat-spinner></mat-spinner>
    } @else {
      <div class="status-chips">
        <app-chip [color]="inventoryAction?.status?.color" [text]="inventoryAction?.status?.name"></app-chip>
      </div>
      <div class="info">
        <div class="name">{{ 'warehouse' | human }}</div>
        <div class="value">{{inventoryAction.warehouse?.name | titlecase}}</div>
        <div class="name">Proveedor</div>
        <div class="value">{{inventoryAction.owner?.name | titlecase}}</div>
        <div class="name">Fecha de Creacion</div>
        <div class="value">{{inventoryAction.created_at | date}}</div>
        @if (inventoryAction.finish) {
          <div class="name">Fecha de Finalización</div>
          <div class="value">{{inventoryAction.completed_at | date}}</div>
        }
        @if (inventoryAction.invoice?.due_date) {
          <div class="name">Fecha de Pago</div>
          <div class="value">{{inventoryAction.invoice.due_date | date}}</div>
        }
      </div>
    }

    <div class="transfer-table-wrapper">
      <table class="transfer-table">
        <thead>
          <tr>
            <th>Producto</th>
            <th>Cantidad</th>
          </tr>
        </thead>
        <tbody>
          @for (inventory_action_product of inventoryActionProducts; track inventory_action_product.id) {
            <tr>
              <td>
                <div>
                  <div class="name">{{inventory_action_product.product.name}}</div>
                  <div class="code">{{inventory_action_product.product.code}}</div>
                </div>
              </td>
              <td>
                {{inventory_action_product.quantity}}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="works-container">
      <app-document-works [order]="inventoryAction" (load)="reloadInventoryAction()" [modalComponent]="true"></app-document-works>
    </div>
  </div>
</ng-template>
